var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4147d5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.19089 10.0383c.15223 1.4408 1.31254 2.6013 2.75269 2.76.99536.1096 2.01624.2017 3.05642.2017s2.06106-.0921 3.0564-.2017c1.4402-.1587 2.6005-1.3192 2.7527-2.76.1045-.98955.1909-2.00436.1909-3.0383 0-1.03395-.0864-2.04876-.1909-3.03829-.1522-1.44085-1.3125-2.60131-2.7527-2.75999-.99534-.10966-2.01622-.20172-3.0564-.20172s-2.06106.09206-3.05642.20172c-1.44015.15868-2.60046 1.31914-2.75269 2.75999-.10454.98953-.19089 2.00434-.19089 3.03829 0 1.03394.08635 2.04875.19089 3.0383z",
    fill: "#d7e0ff"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 8.15326h3.44646c1.10457 0 2-.89543 2-2v-1.89895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.94946 6.2038c-.85531.70077-1.2827 1.12806-1.94944 1.94944.66674.82139 1.09413 1.24868 1.94944 1.94946"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterBlue);
export default __webpack_public_path__ + "static/media/enterBlue.5920f1eb7f5b1c652ff8c129fd4c4107.svg";
export { ForwardRef as ReactComponent };